import React from 'react'

import { withMenuState } from "./../../containers/containerMenuState"
import { withStepsState } from "./../../../shared/containers/containerStepsState"
import getParameterFromURL from "../../../utils/getParameterFromUrl"

import styles from "./menuButton.module.scss"

const MenuButton = props => {
  const { isOpenMenu, onOpenMenu, onCloseMenu, currentIndex } = props
  let firstQuestionC = (getParameterFromURL("firstQuestionC") === "true");
  let firstQuestionD = (getParameterFromURL("firstQuestionD") === "true");

  if (
    currentIndex === 0 && firstQuestionC
    ||
    currentIndex === 0 && firstQuestionD
    ) return '';

  return (
    <div
      className={isOpenMenu ? styles.menuButtonOpen : styles.menuButton}
      onClick={isOpenMenu ? onCloseMenu : onOpenMenu}
    >
      <span className={styles.line1}></span>
      <span className={styles.line2}></span>
      <span className={styles.line3}></span>
    </div>
  )
}

export default withMenuState(withStepsState(MenuButton))